export const ORDER_TYPES = {
	IRRIGATION: 2,
};

export const INITIAL_PARAMS = {
	oa_types: [],
	crops: [],
	crops_detail: [],
	business_centers: [],
	irrigation_sectors: [],
};
